module.exports = __webpack_public_path__ + "img/3.7fe6d5ee.jpg";